import React, { useEffect, useRef, useState } from 'react'
import dropdownStyle from "../DashBoard/ExternalDash/Verifier/VerifyUsers.module.css"
const Dropdown =({
          listType,
          list,
          selectedOption,
          label,
          onSelect,
          type,
          Width="15rem"
        }) => {
          const [isOpen, setIsOpen] = useState(false);
          const dialogBox = useRef(null);
          const handleToggle = () => {
            setIsOpen(!isOpen);
          };
      
          useEffect(() => { 
            const handleClickOutside = (event) => {
              if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                setIsOpen(false);
              }
            };
            document.addEventListener("click", handleClickOutside);
            return () => {
              document.removeEventListener("click", handleClickOutside);
            };
          }, []);
          const handleSelectItem = (item) => {
            onSelect(item, type);
            setIsOpen(false);
          };
          if (listType == 0) {
            return (
              <div
                className={dropdownStyle.letter}
                ref={dialogBox}
                style={{ width: Width, padding: "0px 15px" }}
              >
                <div
                  className={dropdownStyle.lettertype}
                  onClick={handleToggle}
                  style={{ cursor: "pointer" }}
                >
                  <div className={dropdownStyle.selectItem}>
                    <p> {selectedOption?.name || selectedOption.reason ? selectedOption.name || selectedOption.reason : label}</p>
                    {isOpen ? (
                      <img
                        src="/chevrondown.svg"
                        style={{ transform: "rotate(180deg)" }}
                      />
                    ) : (
                      <img src="/chevrondown.svg" />
                    )}
                  </div>
                </div>
                <div
                  className={dropdownStyle.customDropdown}
                  style={{ width: "inherit" }}
                >
                  {isOpen && (
                    <div
                      className={dropdownStyle.dropdownOptions}
                      style={{ maxHeight: "20rem", overflowY: "scroll" }}
                    >
                      {list.map((i) => (
                        <div
                          key={i.id}
                          className={dropdownStyle.dropdownList}
                          onClick={() => handleSelectItem(i)}
                        >
                          {i.name || i.reason}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          }
        }

export default Dropdown